import "./App.css";
import proyects from "./proyects";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h2>Portafolio</h2>
      </header>
      <div className="App-main">
        <div className="App-container-proyect">
          {proyects.map((proyect, index) => (
            <div className="App-proyect" key={index}>
              <div className="App-proyect-img">
                <img src={proyect.image} alt="Proyecto Pizza" />
              </div>
              <div className="App-proyect-title">
                <h2>{proyect.name}</h2>
              </div>
              <div className="description">
                <span>{proyect.description}</span>
              </div>
              <div className="App-proyect-enlaze">
                <a href={proyect.url} target="_black">
                  ir al sitio
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      <footer className="App-footer">
        Gabriel Juárez Gómez 2021 Copyright © Todos los derechos reservados
      </footer>
    </div>
  );
}

export default App;
